module.exports = __webpack_public_path__ + "img/investment.7e9ce5cf.svg";